module.exports = __webpack_public_path__ + "img/reward.d507cf1f.svg";